import cx from 'classnames';
import React from 'react';

import * as styles from './Typography.module.css';

const P = ({
	children,
	as: Component = 'p',
	prose = false,
	font,
	spacing,
	weight = 'light',
	align,
	className = '',
	...rest
}: {
	children: React.ReactNode;
	prose?: boolean;
	font?: 'sm' | 'md' | 'lg';
	spacing?: 'none' | 'sm' | 'md' | 'lg';
	weight?: 'light' | 'normal' | 'bold';
	align?: 'left' | 'center' | 'right';
	as?: React.ElementType;
	className?: string;
}): JSX.Element => {
	return (
		<Component
			className={cx(
				styles.copy,
				{
					[styles[`${font}Font`]]: font,
					[styles[`${spacing}Spacing`]]: spacing,
					[styles[`${weight}Weight`]]: weight,
					[styles[`${align}Align`]]: align,
					[styles.prose]: prose,
				},
				className
			)}
			{...rest}
		>
			{children}
		</Component>
	);
};

export default P;
